<script>
	import '../app.css';
	import '$lib/styles/legal-pages.css';
	import { onMount } from 'svelte';
	import { initializeGrowthBook } from '$lib/services/growthbook.js';
	import { LCPOptimizer } from '$lib/performance.js';
	import EnvironmentDebug from '$lib/components/EnvironmentDebug.svelte';
	import FeatureFlagsDebug from '$lib/components/FeatureFlagsDebug.svelte';
	import PushToast from '$lib/components/PushToast.svelte';
	import { pushStore } from '$lib/stores/push.js';
    import { browser } from '$app/environment';

	let { children } = $props();

	onMount(async () => {
	    if (browser && window.location.hostname === 'auting.it') {
			console.debug = function() {}; // Disabilita console.debug per evitare spam in produzione
		}

		// Inizializza le ottimizzazioni LCP per migliorare Core Web Vitals
		if (browser) {
			try {
				const lcpOptimizer = new LCPOptimizer();
				lcpOptimizer.initialize();
			} catch (error) {
				console.warn('Errore durante l\'inizializzazione delle ottimizzazioni LCP:', error);
			}
		}

		// Inizializza GrowthBook appena l'applicazione si carica
		try {
			console.debug('Inizializzando GrowthBook dal layout principale...');
			await initializeGrowthBook();
			// Hydrate feature flags store once initialized
			const { featureFlags } = await import('$lib/stores/feature-flags.js');
			await featureFlags.refresh(true);
			
			// Forza un piccolo delay per permettere ai componenti di ri-renderizzare
			await new Promise(resolve => setTimeout(resolve, 100));
			
			// Log per debug (solo in dev o se necessario)
			if (import.meta.env.DEV || window.location.search.includes('debug=gb')) {
				console.log('GrowthBook inizializzato:', {
					attributes: window._growthbook?.getAttributes(),
					allFlags: featureFlags.getAll()
				});
			}

			// Init push notifications DOPO l'hydration dei flag, così il kill-switch
			// `web-push-notifications` è disponibile quando `isPushSupported` lo legge.
			if (browser) {
				pushStore.init();
			}
		} catch (error) {
			console.error('Errore durante l\'inizializzazione di GrowthBook:', error);
			console.warn('L\'applicazione continuerà a funzionare senza feature flags remoti');
			// Non bloccare il rendering dell'app
		}
	});
</script>

{@render children()}

<!-- Toast notifiche push in foreground -->
<PushToast />

<!-- Componente di debug per environment (solo in development) -->
<EnvironmentDebug />
{#if browser && import.meta.env.DEV}
	<FeatureFlagsDebug />
{/if}
